module.exports = __webpack_public_path__ + "media/images/landing/home/categories/comercial_cart-59cc48ac4508afc88368938a15fc2176.png";